<template>
    <div class=" flex-1 flex flex-col w-full h-full justify-center items-center overflow-auto">
        <!--上传-->
        <UploadPDF @pdf-result="PDFReadRes" @pdf-url="pdfUrlHandele" v-show="uploadShow" :currentConversation="currentConversation" ></UploadPDF>
        <!--PDF阅读助手-解析-->
        <div v-if="!uploadShow" ref="resizeBox"
            class="w-full h-full flex flex-row overflow-auto"
            :class="{ resizing: resizing }"
            @mousemove="onResizing"
            @mouseup="onResizeStop"
            @mouseleave="onResizeStop">
            <PDFWebView ref="leftViewBox" :pdf_url="pdf_url" class="pdf-webview"
                :style="{ 'pointer-events': resizing ? 'none' : 'auto' }"></PDFWebView>
            <div ref="resizeBar" class="resize-bar" @mousedown="onResizeStart"></div>
            <PDFChatViewer class="pdf-chat-view"
                :currentConversation="currentConversation" :isFetching="isFetching"
                @handleClick="$emit('handleClick', 'close')"></PDFChatViewer>
        </div>
    </div>
</template>
<script>
import UploadPDF from "@/components/pdf/UploadPDF.vue";
// import PDFViewer from "@/components/pdf/pdfPreview/PDFViewer.vue";
import PDFChatViewer from "@/components/pdf/PDFChatViewer.vue";
import PDFWebView from "@/components/pdf/pdfPreview/PDFWebView.vue";

export default {
    components: {
        UploadPDF,
        // PDFViewer,
        PDFWebView,
        PDFChatViewer
    },
    props:['currentConversation','isFetching'],
    data() {
        return {
            uploadShow: true,
            pdf_url: '',
            pdf_name: '',
            // pdf_url: 'http://aistore-test.medlive.cn/uploadfile/pdf/2024_04/24/1713943453361.3.pdf',
            // pdf_url: 'https://medpdf-test.kydev.net/static/uploadfile/20240416/20240416173708_661e46c4581b5.pdf',
            // 预览区域拖动相关变量
            resizing: false,
            resizeOffsetStart: 0,
            resizeWidthStart: 0,
            resizeBoxWidth: 0,
        };
    },
    mounted(){
        // console.log(this.currentConversation);
    }, 
    watch: {
        currentConversation(newVal, oldVal) {
            console.log('pdf read -- change currentConversation', newVal);
            this.uploadShow = newVal.pdf_url ? false : true;
            this.pdf_url = newVal.pdf_url;
        },
    },
    methods: {
        // pdf 上传、解析完成
        PDFReadRes(res){
            console.log('get res',res);
            this.uploadShow = false;
            // 更新会话列表，选中新增会话
            this.$bus.$emit('updateChatById',res.insert_chat_id)
        },
        pdfUrlHandele(pdf_data){
            this.uploadShow = false;
            this.pdf_url = pdf_data.fileUrl;
            this.pdf_name = pdf_data.fileName;
            // this.pdf_url = 'https://aigc-test.kydev.net/uploads/mj/files/20240416173532_661e46647ceab.pdf';
        },
        onResizeStart(e) {
            this.resizing = true
            this.resizeOffsetStart = e.clientX
            this.resizeWidthStart = parseInt(getComputedStyle(this.$refs.leftViewBox.$el).width)
            this.resizeBoxWidth = parseInt(getComputedStyle(this.$refs.resizeBox).width)
            e.preventDefault();
            e.stopPropagation();
        },
        onResizing(e) {
            // 仅在鼠标按下时有效
            if (!this.resizing) return
            const offsetX = e.clientX - this.resizeOffsetStart;
            // 限制最大最小宽度
            let width = this.resizeWidthStart + offsetX
            if (width < 360) width = 360
            if (width > this.resizeBoxWidth - 360) width = this.resizeBoxWidth - 360
            this.$refs.leftViewBox.$el.style.width = width + 'px'
        },
        onResizeStop(e) {
            this.resizing = false
        },
    },
};
</script>

<style lang="scss" scoped>
.resize-bar {
    flex-shrink: 0;
    width: 5px;
    background: #eee;
    cursor: col-resize;

    &:hover {
        background: #ccc;
    }
}

.resizing {
    cursor: col-resize;

    .resize-bar {
        background: #ccc;
    }
}

.pdf-webview {
    flex: 0 0 auto;
    width: 50%;
}

.pdf-chat-view {
    flex: 1 1 auto;
    width: 50%;
}
</style>
